/** True when the visitor asked for less motion. Read once per call. */
export function reducedMotion(): boolean {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * Runs `enter` the first time `el` is at least 20% on screen, once. The
 * scroll-reveal for every section hangs off this. The function it returns
 * stops watching before then.
 */
export function inView(
  el: Element,
  enter: () => void,
  threshold = 0.2,
): () => void {
  if (!('IntersectionObserver' in window)) {
    enter();
    return () => {};
  }
  const io = new IntersectionObserver(
    (entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        io.disconnect();
        enter();
      }
    },
    { threshold },
  );
  io.observe(el);
  return () => io.disconnect();
}

/** Adds .is-in to every [data-reveal] block as it first scrolls into view. */
export function reveal(root: ParentNode = document): void {
  root.querySelectorAll('[data-reveal]').forEach((el) => {
    inView(el, () => el.classList.add('is-in'));
  });
}

/** setInterval that skips its callback while the tab is hidden. */
export function whileVisible(fn: () => void, ms: number): number {
  return window.setInterval(() => {
    if (!document.hidden) fn();
  }, ms);
}
